import USBButton from "@usb-shield/react-button";
import USBBadge from "@usb-shield/react-badge";

const Card = ({
  img,
  name,
  description,
  report,
  buttonText,
  onButtonClick,
}) => {
  return (
    <div className="card-container">
      <div className="card">
        {report.killSwitchEnabled && (
          <div className="card-badge">
            <USBBadge text="Under Maintenance" status="Caution" />
          </div>
        )}
        <div className="card-icon">
          <img src={img} alt="dashboard-icon" width="50" height="50" />
        </div>
        <div className="card-title" title={name}>
          <span className="card-title-text">{name}</span>
        </div>
        <div className="card-description">{description}</div>
        <USBButton
          className="card-button"
          disabled={report.killSwitchEnabled || report.disabled}
          onPress={() => onButtonClick(report)}
        >
          {buttonText}
        </USBButton>
      </div>
    </div>
  );
};

export default Card;
